import { ScheduleHistory } from '../../../hooks/useScheduleReporting';

interface ScheduleHistoryTableProps {
  scheduleHistory: ScheduleHistory[];
}

const ScheduleHistoryTable: React.FC<ScheduleHistoryTableProps> = ({ scheduleHistory }) => {
  return (
    <div className="max-w-7xl overflow-x-auto p-4">
      <table className="min-w-full table-fixed border-collapse">
        <thead>
          <tr className="bg-gray-100">
            <th className="w-32 border p-2">Listener</th>
            <th className="w-32 border p-2">Date</th>
            <th className="w-40 border p-2">Hours Active During Schedule</th>
            <th className="w-32 border p-2">Scheduled Hours</th>
            <th className="w-32 border p-2">Active Hours</th>
            <th className="w-40 border p-2">Schedule Start Time</th>
            <th className="w-40 border p-2">Schedule End Time</th>
            <th className="w-40 border p-2">Actual Start Time</th>
            <th className="w-40 border p-2">Actual End Time</th>
          </tr>
        </thead>
        <tbody>
          {scheduleHistory.map((history) => (
            <tr key={history.listener_role_id}>
              <td className="border p-2">{history.display_name}</td>
              <td className="border p-2">{history.formattedScheduleDay}</td>
              <td className="border p-2">{history.hoursActiveDuringSchedule}</td>
              <td className="border p-2">{history.formattedScheduleDuration}</td>
              <td className="border p-2">{history.formattedActiveDuration}</td>
              <td className="border p-2">{history.formattedScheduledStart}</td>
              <td className="border p-2">{history.formattedScheduledEnd}</td>
              <td className="border p-2">{history.formattedActualStart}</td>
              <td className="border p-2">{history.formattedActualEnd}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ScheduleHistoryTable;
